const DEFAULT_FALLBACK_IMAGE =
  "/images/portfolio/portfolio-default-task-background.jpg";

/**
 * Image error handler that sets a fallback image.
 * Use as `@error="onImageError"` on `<img>` tags.
 * Defaults to the task banner; pass a custom path for other fallbacks.
 */
export const onImageError = (
  event: Event,
  fallback: string = DEFAULT_FALLBACK_IMAGE,
): void => {
  const target = event.target as HTMLImageElement;
  target.src = fallback;
};

/**
 * Resolve a backend image path (typically a leading-slash path relative to the
 * Laravel host, e.g. `"/cDLNyw4M/258/.../10.jpg"`) to an absolute URL that
 * `<img :src>` / `<c-avatar :src>` can load directly. Returns `null` for
 * empty / missing paths so callers can fall back to initials or a default.
 */
export const toAbsoluteImageUrl = (
  path: string | null | undefined,
): string | null => {
  if (!path) {
    return null;
  }
  const base = import.meta.env.VITE_LARAVEL_URL ?? "";
  const separator = path.startsWith("/") ? "" : "/";
  return `${base}${separator}${path}`;
};
